module.exports = __webpack_public_path__ + "img/1.fef5a68f.png";